<template>
  <div>
    <div v-loading="loading">
      <Form :rules="DutyRules" ref="DutyRefs" :model="dutyForm">
        <Row>
          <Col :span="12">
            <FormItem label="日期:" prop="dutyDate">
              <DatePicker type="date" v-model="dutyForm.dutyDate" placeholder="选择日期"
                          :disabled="!!currentDuty.id"></DatePicker>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="值班岗位:" prop="post">
              <Select type="text" v-model="dutyForm.post" placeholder="请选择值班岗位">
                <Option v-for="(item,index) in dutyTypeList" :key="index" :value="item.id"
                        :label="item.name"></Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col :span="24">
            <FormItem label="值班人员:" prop="dutyPersonnel">
              <Input type="text" v-model="dutyForm.dutyPersonnel" placeholder="请输入值班人员"></Input>
            </FormItem>
          </Col>
        </Row>
<!--        <Row>-->
<!--          <Col :span="24">-->
<!--            <FormItem label="值班人员手机号:" prop="iphone">-->
<!--              <Input v-model="dutyForm.iphone" placeholder="值班人员手机号"></Input>-->
<!--            </FormItem>-->
<!--          </Col>-->
<!--        </Row>-->
        <Row>
          <Col :span="24">
            <FormItem label="值班电话:" prop="dutyIphone">
              <Input v-model="dutyForm.dutyIphone" placeholder="值班电话"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewDuty",
  props: {
    currentDuty: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    currentDuty: {
      handler: function (val) {
        console.log('val', val)
        if (val.id) {
          this.getDutyDetailById(val.id)
        }
      },
      deep: true
    }
  },
  data() {
    return {
      loading: false,
      dutyForm: {
        dutyDate: '',// 值班日期
        post: '',// 值班岗位 岗位(0带班领导，1值班人员)
        dutyPersonnel: '',// 值班人员
        // iphone: '',// 联系方式
        dutyIphone: ''
      },
      DutyRules: {
        dutyDate: [
          { required: true, message: '日期不可为空', trigger: 'blur', type: 'date' }
        ],
        post: [
          { required: true, message: '岗位不可为空', trigger: 'blur' }
        ],
        dutyPersonnel: [
          { required: true, message: '值班人员不可为空', trigger: 'blur' }
        ],
        // iphone: [
        //   { required: true, message: '值班人员手机号不可为空', trigger: 'blur' },
        //   { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" }
        // ],
        dutyIphone: [
          { required: true, message: '值班电话不可为空', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" }
        ]
      },
      dutyTypeList: []
    }
  },
  mounted() {
    this.getDutyTypeList()
  },
  methods: {
    // 获取某个值班信息
    getDutyDetailById(id) {
      this.loading = true
      this.$http.get(`/api/dutyCalendars/${ id }`).then(res => {
        if (res.status === 200) {
          this.dutyForm = res.data
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
        this.$Message.error('获取值班信息失败')
      })
    },
    // 获取值班类型列表
    getDutyTypeList() {
      this.$http.get(`/api/dutyPosts`).then(res => {
        if (res.status === 200) {
          this.dutyTypeList = res.data.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

</style>
